import { styled } from '@material-ui/core'
import BaseButton from 'shared/components/Button'

const WRAPPER_HEIGHT = 40

export const Wrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  height: WRAPPER_HEIGHT,
})

export const Button = styled(BaseButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  width: 'max-content',
  fontWeight: 600,
}))
